import { v4 as uuidv4 } from 'uuid';
import mock from '../config/mock';

mock.onGet('/api/admins').reply(200, {

    admins: [
        {
            id: uuidv4(),
            name: 'asd',
            email: 'asd@asd.com',
            contact: '0987654321',
            position: 'asd'
        },
        {
            id: uuidv4(),
            name: 'qwe',
            email: 'qwe@qwe.com',
            contact: '0987654321',
            position: 'zxc'
        },
        {
            id: uuidv4(),
            name: 'bnm',
            email: 'bnm@bnm.com',
            contact: '0987654321',
            position: 'uio'
        },
    ]

    
            
});

mock.onGet('/api/admindetails/1').reply(200, {

    admindetails: [
        {
            name: 'asd',
            email: 'asd@asd.com',
            contact: '0987654321',
            position: 'asd'
        },
    ]
});